(() => {
  'use strict';

  const STORAGE_KEY = 'showgift_search_original_query';

  function isSearchPage() {
    return window.location.pathname.endsWith('/search');
  }

  function storedQuery() {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) || '';
    } catch (_) {
      return '';
    }
  }

  function forgetStoredQuery() {
    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (_) {}
  }

  function clearStickyQueryOutsideSearch() {
    if (isSearchPage()) return;

    const stored = storedQuery().trim();
    if (!stored) return;

    document.querySelectorAll('input[type="search"]').forEach(input => {
      if (!(input instanceof HTMLInputElement)) return;
      if (input.value.trim() !== stored) return;

      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    forgetStoredQuery();
  }

  document.addEventListener('input', event => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.type === 'search' && !input.value.trim()) {
      forgetStoredQuery();
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearStickyQueryOutsideSearch, { once: true });
  } else {
    clearStickyQueryOutsideSearch();
  }

  window.addEventListener('pageshow', clearStickyQueryOutsideSearch);
})();
